<app-select-items
  [items]="allJobTitles$ | async"
  [actionForAdmin]="true"
  [titleVisible]="'components.jobTitles.labels.titleVisible' | translate"
  [titleInvisible]="'components.jobTitles.labels.titleInvisible' | translate"
  [descriptionVisible]="'components.jobTitles.labels.descriptionVisible' | translate"
  [descriptionInvisible]="'components.jobTitles.labels.descriptionInvisible' | translate"
  (save)="onSave($event)"
></app-select-items>
